import { openBlock as t, createElementBlock as e, createStaticVNode as l } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, a = /* @__PURE__ */ l('<path fill="#F0F0F0" d="M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"></path><path fill="#000" d="M12.174 13.043h26.582C35.93 5.428 28.599 0 20 0A19.935 19.935 0 0 0 5.858 5.859l6.316 7.184Z"></path><path fill="#6DA544" d="M12.174 26.956h26.582C35.93 34.572 28.599 40 20 40a19.935 19.935 0 0 1-14.142-5.86l6.316-7.185Z"></path><path fill="#D80027" d="M5.858 5.859c-7.81 7.81-7.81 20.472 0 28.282L20 20 5.858 5.859Z"></path><path fill="#F0F0F0" d="m7.938 15.652 1.097 2.296 2.48-.573-1.11 2.289 1.992 1.58-2.481.56.006 2.544-1.984-1.592-1.985 1.592.007-2.544-2.482-.56 1.993-1.58-1.11-2.29 2.48.574 1.097-2.296Z"></path>', 5), h = [
  a
];
function c(n, p) {
  return t(), e("svg", o, [...h]);
}
const i = { render: c };
export {
  i as default,
  c as render
};
